module.exports = __webpack_public_path__ + "static/media/Caution.svg";